export default "/bottom-fade.621c2014-e9f408.png";